import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const TwoRow = ({ label = '', subLabel = '' }) => (
    <div className="fm-select-row fm-select-row__three">
        <p className="fm-select-row__label">{label}</p>
        <p className="fm-select-row__sub-label">{subLabel}</p>
    </div>
);

TwoRow.propTypes = {
    label: PropTypes.string,
    subLabel: PropTypes.string,
};

export default TwoRow;
